import { Button, Spacer, Text } from '@sparemin/blockhead';
import * as React from 'react';

import { useSelector } from 'react-redux';
import useCost from 'hooks/useCost';
import { myPodcastPromoCreditsSelector } from 'redux/modules/pricing';
import { DISCO_ADS_PROMO_LINK } from 'utils/constants';
import { block } from './utils';

export interface ProGrowSubscriptionCreditsProps {}

const ProGrowSubscriptionCredits: React.FC<ProGrowSubscriptionCreditsProps> = () => {
  const myPodcastPromoCredits = useSelector(myPodcastPromoCreditsSelector);

  const remainingCredits = useCost(
    myPodcastPromoCredits?.remainingMilliCent / 1000,
  );

  return (
    <Spacer
      space="12px"
      orientation="vertical"
      align="center"
      justify="center"
      className={block('credits')}
    >
      <Text variant="label" size="14px">
        Podcast promo
      </Text>

      <Text variant="label" weight={400}>
        Campaign credit remaining this month:
      </Text>

      <Spacer
        space="8px"
        orientation="horizontal"
        align="center"
        justify="center"
      >
        <Text variant="label" size="24px" weight={400}>
          {remainingCredits}
        </Text>
      </Spacer>

      <Button
        variant="special"
        as="a"
        rel="noreferrer noopener"
        href={DISCO_ADS_PROMO_LINK}
        target="_blank"
        className={block('create')}
      >
        create a campaign
      </Button>
    </Spacer>
  );
};

export default ProGrowSubscriptionCredits;
